import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHeader, LoadingState } from "@/components/common";
import { HistoryPanel } from "@/components/research/HistoryPanel";
import { BacktestForm } from "@/components/research/BacktestForm";
import { BacktestResult } from "@/components/research/BacktestResult";
import { StrategyCompare } from "@/components/research/StrategyCompare";
import { FlaskConical } from "lucide-react";

export default function Backtesting() {
  const [result, setResult] = useState(null);
  const src = useQuery({ queryKey: ["hist-sources"], queryFn: async () => (await api.get("/history/sources")).data });
  if (src.isLoading) return <LoadingState label="Loading data sources..." />;
  return (
    <div className="space-y-6" data-testid="backtesting-page">
      <PageHeader title="Backtesting Laboratory" subtitle="Real Binance history · reproducible runs · research only" icon={FlaskConical} demo={false} testId="backtesting-header" />
      <HistoryPanel sources={src.data} />
      <BacktestForm onResult={setResult} />
      {result && <BacktestResult r={result} />}
      <StrategyCompare refreshKey={result?.id} />
    </div>
  );
}
